module.exports = __webpack_public_path__ + "img/a4g.c5e051f2.svg";